/**
 * @file Request-From 请求头管理
 * @description 封装多平台 Request-From 请求头的设置与清理
 */

interface RequestFromParams {
  client: string
  version: string
  cuid: string
  domain?: string
}

/**
 * 构建 Request-From 字符串并写入 sessionStorage
 */
export function setRequestFromHeader(params: RequestFromParams): void {
  const { client, version, cuid, domain = 'common' } = params
  const requestFrom = `client=${client};domain=${domain};version=${version};cuid=${cuid}`
  sessionStorage.setItem('Request-From', requestFrom)
}

/**
 * 清理 Request-From 请求头
 */
export function clearRequestFromHeader(): void {
  sessionStorage.removeItem('Request-From')
}
